// extracted by mini-css-extract-plugin
export var toc = "index-module--toc--16eb9";
export var toc__ellipsis = "index-module--toc__ellipsis--2a1a1";
export var toc__link = "index-module--toc__link--1571c";
export var toc__linkActive = "index-module--toc__link--active--2b793";
export var toc__list = "index-module--toc__list--19652";
export var toc__title = "index-module--toc__title--91e5c";